import type { AdminProduct } from '@titularis/api-client';

/**
 * Se o produto aparece na vitrine, e por quê.
 *
 * **A regra é do servidor, e esta função a repete de propósito.** O
 * `listarCatalogo` só devolve produto ativo **com preço ativo** - um produto
 * ligado e sem preço não aparece para ninguém, e da tela de administração ele
 * parecia estar à venda. Dizer "sem preço" em vez de "à venda" é a diferença
 * entre descobrir isso aqui e descobrir por um aluno que não achou o botão.
 *
 * Repetir a regra é aceitável porque ela é uma linha e porque o custo de errar
 * é assimétrico: aqui ela só escolhe uma etiqueta, e quem decide o que se vende
 * continua sendo a API (G-POLICY).
 */
export type SituacaoDoProduto = 'a_venda' | 'sem_preco' | 'fora_de_venda';

export function situacaoDoProduto(
  produto: Pick<AdminProduct, 'active'> & { precos: { active: boolean }[] },
): SituacaoDoProduto {
  if (!produto.active) return 'fora_de_venda';
  return produto.precos.some((preco) => preco.active) ? 'a_venda' : 'sem_preco';
}

export const SITUACAO_LABEL: Record<SituacaoDoProduto, string> = {
  a_venda: 'À venda',
  sem_preco: 'Sem preço ativo',
  fora_de_venda: 'Fora de venda',
};

export const SITUACAO_COR: Record<SituacaoDoProduto, string> = {
  a_venda: 'green',
  // Laranja e não vermelho: não é uma decisão, é um esquecimento.
  sem_preco: 'orange',
  fora_de_venda: 'default',
};

/**
 * Os números do topo da tela.
 *
 * Somados no cliente sobre a lista inteira, que vem numa chamada só: o catálogo
 * tem um punhado de produtos, e uma rota de totais seria uma segunda verdade
 * para manter de pé.
 */
export function somarCatalogo(produtos: AdminProduct[]) {
  return {
    receitaCents: produtos.reduce((total, produto) => total + produto.vendas.receitaCents, 0),
    pagos: produtos.reduce((total, produto) => total + produto.vendas.pagos, 0),
    abertos: produtos.reduce((total, produto) => total + produto.vendas.abertos, 0),
    aVenda: produtos.filter((produto) => situacaoDoProduto(produto) === 'a_venda').length,
  };
}
